/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Общий вид для страницы категории 2 уровня.
   */
  app.CategoryCommonView = app.RestCommonView.extend({
    el: '[data-jsview="category"] .reducer',
    sortTemplateId: '#main-sort-filter',
    viewTypeTemplateId: '#catalog-viewtype-switch',
    limitSwitchTemplateId: '#catalog-limit-switch',
    shownSortThreshold: 3,
    MAX_WORD_LENGTH: 13,
    events: {
      'click .catalog-sort .js-sort': 'changeSort',
      'click .more-sort, .js-toggle-options-popup': 'toggleOptionsPopup',
      'click .catalog-show .js-page-size-value': 'changePageSize',
      'click .catalog-filter__views span': 'handleChangeViewType',
      'click .js-show-all-categories': 'showAllCategories',
      'click .js-hide-last-categories': 'hideLastCategories',
      'click .catalog-sort .sort-chosen': 'showSort',
      'click .catalog-sort .sort-list': 'showSort',
      'click .filter_but': 'loadFilters',
      'click .mature': 'setMature',
      'click': 'hideOptionsPopup',
      'click .js-viewtype': 'changeViewTypeOnMobile',
    },
    additionalOptions: [
      'sortTemplateId',
      'viewTypeTemplateId',
      'limitSwitchTemplateId',
      'router',
      'mainWindow',
      'currencies',
      'currency',
      'jsView',
      'fader',
      'withEmptyFilter',
      'withNews',
      'isGalleryEnabled',
      'jsModel',
      'isRootFilterPage',
      'wish',
      'createNotification',
    ],
    /**
     * @inheritDoc
     */
    run: function () {
      this.childViews = {};
      this.childViews.popups = [];
      this.lastElemPosition = null;
      this.lastItemsQtyOnPage = null;
      var that = this;
      this.activeFilterPageModel = new app.FilterPage();
      this.$filterBlock = this.$('.side-filter');
      // устанавливаем categoryId
      this.getCategoryId();
      this.$('.catalog-holder').attr('data-current-viewtype', this.model.viewtype);
      // вид с каталогом товаров.
      this.childViews.itemsView = new app.CategoryItemsView({
        model: this.model,
        router: this.router,
        cart: this.cart,
        settlement: this.settlement,
        user: this.user,
        currency: this.currency,
        mainWindow: this.mainWindow,
        fader: this.fader,
        withEmptyFilter: this.withEmptyFilter,
        isGalleryEnabled: this.isGalleryEnabled,
        activeFilterPageModel: this.activeFilterPageModel,
        isRootFilterPage: this.isRootFilterPage,
        isDynamicDeliverySegment: app.features && app.features.is_dynamic_item_delivery_view_catalog,
        isShowOneItemInSearch: app.features && app.features.is_show_one_item_in_search,
        createNotification: this.createNotification,
        wish: this.wish
      });
      this.newLoader = this.childViews.itemsView.childViews.loader;
      if (this.infinitePreloader) {
        this.infinitePreloader.isNewInfiniteLoader = Boolean(this.newLoader);
      }

      // вид с новостями.
      if (this.withNews && this.model instanceof app.Search) {
        this.childViews.newsView = new app.CategoryNewsItemsView({
          itemsView: this.childViews.itemsView,
        });
      }

      this.initFilterPages();
      this.initPagination();

      // templates
      this.sortFilterTemplate = app.helpers.TemplateHelper.getTemplate(this.sortTemplateId);
      this.viewTypeTemplate = app.helpers.TemplateHelper.getTemplate(this.viewTypeTemplateId);
      this.limitSwitchTemplate = app.helpers.TemplateHelper.getTemplate(this.limitSwitchTemplateId);
      this.totalCountHeaderTemplate = app.helpers.TemplateHelper.getTemplate('#total-count-header');

      // в случае избранного
      if (this.model.canRemoveItems) {
        this.delegateEvents(_.extend(this.events, {'click .wish-reset': 'resetCategoryFilters'}));
        if (!app.isMobile) {
          this.wishItemsCounterTemplate = app.helpers.TemplateHelper.getTemplate('#left-wish-item-counter');
          this.listenTo(Backbone, 'update-chosen-filters', this.renderWishItemsCounter);
        }
      }
      //слайдер товаров с суперценой
      if (this.$('.loco-items').length) {
        this.childViews.locoItemsView = new app.LocoItemsView({
          categoryId: this.model.categoryId,
          currencies: this.currencies,
          currency: this.currency,
          cart: this.cart,
          mainWindow: this.mainWindow,
        });
      }
      if (this.$('.part-catalog').length) {
        this.childViews.partSelectionView = new app.PartSelectionView({
          user: this.user,
        });
      }

      this.$foundCategoriesHeader = this.$('.js-categories-qty-text');
      if (this.$foundCategoriesHeader.length) {
        this.listenTo(Backbone, 'found-in-categories', this.updateFoundCategoriesHeader);
      }
      this.togglePreventScroll(false);
      this.$('.sl-hide').hide();
      this.seoTextInitialize();
      this.listenTo(Backbone, 'toggle-filters-button', this.toggleFilterButton);
      this.listenTo(this.childViews.itemsView, 'rendered', this.render);
      this.listenTo(Backbone, 'change-category-id', this.clearScrollState);
      this.listenTo(this.mainWindow, 'window.resize', this.seoTextInitialize);
      this.listenTo(Backbone, 'change-category-wrapper', this.changeCategoryWrapper);
      // слушаем событие обновления коллекции категории
      this.listenTo(this.childViews.itemsView, 'reached-the-end', this.setReachTheEnd);
      this.listenTo(Backbone, 'removedFromWish', this.updateOnRemoveAndAdd);
      this.listenTo(this.model, 'removeCheckedFromWish', this.updateOnRemoveAndAdd);
      this.listenTo(this.cart, 'addedCartByArticle', this.updateOnRemoveAndAdd);
      this.listenTo(this.router, 'infinite-scroll', this.infiniteScroll);
      this.listenTo(this.router, 'change-get-params', function (changedParams) {
        if (changedParams.indexOf('viewtype') > -1) {
          this.$('.catalog-holder').attr('data-current-viewtype', this.model.viewtype);
        }
        if (!this.isRootFilterPage && changedParams.indexOf('f') < 0) {
          that.listenToOnce(that.model, 'sync', function () {
            that.updateLayoutOnFilterPageApplied(that.activeFilterPageModel);
          });
        }
        if (!app.isMobile || app.isMobile && this.router.isRouterNavigate) {
            that.choice(changedParams);
        }
      });

      // организация бесконечного скролла

      this.listenTo(this, 'InfiniteScroll', function () {
        this.renderInfinitePreloader();
        this.fetchScroll();
      });

      // В поиске нужно очищать все содержимое, кроме заголовка, если искомого товара нет в наличии

      if (this.router.type === 'search' && !app.isMobile) {
        this.listenTo(Backbone, 'common-view-clear', this.clear);
        this.listenTo(Backbone, 'common-view-fill', this.fill);
      }

      // слушаем смену города

      this.listenTo(app.settlement, 'change:settlement_id', (function () {
        this.listenToOnce(app.settlement, 'sync', this.refreshCollection);
      }).bind(this));
      this.listenTo(Backbone, 'refresh-collection', this.refreshCollection);
      if (app.isMobile) {
        this.listenTo(Backbone, 'update-chosen-filters', this._setFiltersQtyOnMobile);
      }
      this._showPopupSubCategory();
      // this.categorySeoText = this.$('.sl-description-text').html();
      this.categoryHeaderText = this.$('.title_home').html();
      this.listenTo(Backbone, 'filter-page-applied', this.updateFilterPageModel);
      this.listenTo(Backbone, 'filter-page-cleared', this.clearFilterPage);
      this.listenTo(this.activeFilterPageModel, 'change:base_url change:slug', this.updateLayoutOnFilterPageApplied);
      this.listenTo(Backbone, 'toggle-filter-block', this.toggleFilterBlock);
      if (app.features && app.features.is_new_category_icons) {
        this.initCategoryMenu();
      }
    },

    /**
     * Инициализация меню категорий с кнопкой Ещё
     */
    initCategoryMenu: function () {
      this.moreButtonTemplate = app.helpers.TemplateHelper.getTemplate('#more-categories-template');
      this.$categoryList = $('.ellipse-categories-view .category-menu');
      this.findLongWords();
      if (!this.$categoryList.hasClass('expanded')) {
        this.listenTo(Backbone, 'window.resize.debounced', this.wrapCategoryMenuInOneRow);
        this.wrapCategoryMenuInOneRow();
      }
    },

    /**
     * Поиск длинных слов в названии категорий.
     */
    findLongWords: function () {
      var categoryNames = this.$('.category-link-name');
      var that = this;
      categoryNames.each(function(index, element) {
        var name = $(element);
        if (name.html().length > that.MAX_WORD_LENGTH) {
          var wordsList = name.html().split(' ');
          var hasLongWord = _.some(wordsList, function(word) {
            return word.length > that.MAX_WORD_LENGTH;
          });
          if (hasLongWord) {
            name.addClass('long-word');
          }
        }
      });
    },

    /**
     * Обработчик смены типа отображения каталога.
     * @param {jQuery} e Событие.
     */
    handleChangeViewType: function (e) {
      Backbone.trigger('apply-viewtype', e);
    },

    /**
     * Обновляет блок с количеством категорий в которых найден запрос.
     * @param {Number} categoriesQty - количество категорий.
     */
    updateFoundCategoriesHeader: function (categoriesQty) {
      var text = '';
      if (categoriesQty) {
        var textPart = 'Найдено в ';
        var declinedTextPart = app.helpers.DeclinationHelper
          .format(categoriesQty, [' категории', ' категориях', ' категориях']);
        text = textPart + categoriesQty + declinedTextPart;
      }
      this.$foundCategoriesHeader.length
      && this.$foundCategoriesHeader.text(text);
    },

    /**
     * Переключение видимости блок фильтров.
     * @param {Boolean} shouldHide - блок должен скрыться.
     */
    toggleFilterBlock: function (shouldHide) {
      this.$filterBlock.toggleClass('not_display', shouldHide);
      this.childViews.itemsView.$el.toggleClass('filter-block-hidden', shouldHide);
    },

    /**
     * Переключение видимости кнопки "Фильтры".
     * @param {boolean} shouldHide кнопка должна скрыться.
     */
    toggleFilterButton: function (shouldHide) {
      this.$('.js-toggle-filters').toggleClass('has-no-filters', shouldHide);
      this.$('.items-actions-wrap').toggleClass('without-offset', shouldHide);
    },

    /**
     * Инициализация подфильтровых страниц
     */
    initFilterPages: function () {
      var topFilterPagesWrapper = this.$('.top-filter-pages .filter-pages-wrapper'),
        bottomFilterPagesWrapper = this.$('.bottom-filter-pages .filter-pages-wrapper'),
        groupFilterPages = this.$('.group-filter-pages .filter-pages-wrapper');
      this.saveFilterPagesToModel();
      if (topFilterPagesWrapper.length
        || bottomFilterPagesWrapper.length
        || groupFilterPages.length) {
        this.filterPageModel = new app.FilterPage();
        this.listenTo(Backbone, 'change-category-id', function (slug, categoryId) {
          this.filterPageModel.requestParameters = {
            base_url: slug,
            for_catalog: 1,
          };
          this.filterPageModel.fetch();
        });
      }
      if (topFilterPagesWrapper.length && !app.isMobile) {
        this.childViews.topCategoryFilterPagesView = new app.CategoryFilterPagesView({
          el: topFilterPagesWrapper,
          mainWindow: this.mainWindow,
          isMoreButtonInline: true,
          model: this.filterPageModel,
          filterPageKey: 'top',
          router: this.router,
        });
      }
      if (bottomFilterPagesWrapper.length && !app.isMobile) {
        this.childViews.bottomCategoryFilterPagesView = new app.CategoryFilterPagesView({
          el: bottomFilterPagesWrapper,
          heightSubfilterPages: 160,
          isMoreButtonInline: false,
          model: this.filterPageModel,
          filterPageKey: 'bottom',
          mainWindow: this.mainWindow,
        });
      }
      if (groupFilterPages.length) {
        if (app.isMobile) {
          this.childViews.mobileGroupFilterPagesView = new app.MobileGroupFilterPagesView({
            el: groupFilterPages,
          });
        } else {
          this.childViews.categoryGroupFilterPagesView = new app.CategoryFilterPagesView({
            el: groupFilterPages,
            heightSubfilterPages: 160,
            model: this.filterPageModel,
            isGroupFilterPages: true,
            mainWindow: this.mainWindow,
            filterPageKey: 'grouped',
          });
        }
      }
      if (topFilterPagesWrapper.length && app.isMobile) {
        this.$('.filter_but').click(function () {
          // Timeout, т.к. не успевает определяться правильный offsetTop у li.filter-page
          setTimeout(function () {
            this.childViews.topCategoryFilterPagesView = new app.CategoryFilterPagesView({
              el: topFilterPagesWrapper,
              heightSubfilterPages: 95,
              isMoreButtonInline: false,
              model: this.filterPageModel,
              filterPageKey: 'top',
              mainWindow: this.mainWindow,
            });
          }.bind(this), 0);
        }.bind(this));
      }
      if (bottomFilterPagesWrapper.length && app.isMobile) {
        this.childViews.bottomCategoryFilterPagesView = new app.CategoryFilterPagesView({
          el: bottomFilterPagesWrapper,
          heightSubfilterPages: 95,
          isMoreButtonInline: false,
          model: this.filterPageModel,
          filterPageKey: 'bottom',
          mainWindow: this.mainWindow,
        });
      }
    },

    /**
     * Инициализация пагинации
     */
    initPagination: function () {
      var PaginationView = app.PaginationView;
      if (app.isMobile) {
        PaginationView = app.MobilePaginationView;
      }
      this.childViews.paginationView = new PaginationView({
        model: this.model,
        router: this.router,
      });
    },

    /**
     * Запускает fetch коллекции с заданными опциями
     * @param options
     * @param response
     */
    refreshCollection: function (options, response) {
      if (response) {
        options = { filters: true };
      }
      if (this.model.mode === 'infinite') {
        this.router.infiniteFetch();
        this.model.getPage(1, options);
      } else {
        this.model.getPage(this.model.state.currentPage, options);
      }
    },
    /**
     * Очищение общих элементов управления в поиске, если товара нет в наличии
     */
    clear: function () {
      if (this.model.getFilter() === null) {
        this.childViews.itemsView.$el.hide();
      }
      this.$('.catalog-filter').hide();
      this.$('.catalog-row').hide();
      this.$('.search-results__aside').hide();
    },

    /** @inheritDoc */
    choice: function (changedKeys) {
      this.lastElemPosition = null;
      this.lastItemsQtyOnPage = null;
      app.RestCommonView.prototype.choice.apply(this, arguments);
    },
    /**
     * Восстановление общих элементов управления в поиске
     */
    fill: function () {
      this.childViews.itemsView.$el.show();
      this.$('.catalog-filter').show();
      this.$('.catalog-row').show();
      this.$('.search-results__aside').show();
    },

    /**
     * Показывает или скрывает количество выбранных фильтров в мобильной версии.
     * @private
     */
    _setFiltersQtyOnMobile: function (length) {
      var filterQtyFlag = this.$('.filter_but .selected-filter');
      if (length) {
        filterQtyFlag.removeClass('not_display');
        filterQtyFlag.html(length);
      } else {
        filterQtyFlag.addClass('not_display');
      }
    },

    /**
     * Установка высоты блоку с сео-текстом.
     */
    seoTextInitialize: function () {
      var slDescriptionTextHeight = this.$('.sl-description-text').outerHeight();
      this.$('.seo-text-category').height(slDescriptionTextHeight);
    },

    /**
     * @inheritDoc
     *
     * @returns app.CategoryCommonView
     */
    render: function () {
      var activeSort = this.model.sort;
      if (app.isMobile && this.$el.hasClass('not_display')) {
        setTimeout((function () {
          this.$el.removeClass('not_display');
        }).bind(this), 250);
      }
      if (!app.isMobile) {
        this.extractShownSortTypes(activeSort);
      }
      var templatesAvailable = _.includes(this.sortFilterTemplate.source, 'more-sort');
      this.$('.catalog-sort').html(this.sortFilterTemplate({
        sort: activeSort,
        hasDiscountItems: this.model.state.hasDiscountItems,
        hasMeanRatingSort: this.model.state.hasMeanRatingSort,
        sortTypes: templatesAvailable && this.shownSortThreshold && this.showSortTypes
          ? this.showSortTypes
          : this.model.sortTypes,
        moreSortTypes: this.moreSortTypes,
        isDiscountHighlight: !(this.model instanceof app.WishItems),
      }));
      this.$('.catalog-filter__views').html(this.viewTypeTemplate({
        viewtype: this.model.viewtype,
      }));
      this.$('.catalog-show').html(this.limitSwitchTemplate({
        pageSize: this.model.state.pageSize,
        mode: this.model.mode,
      }));

      var totalCountHeader = this.$('.total-count-header');
      if (totalCountHeader.length && app.isMobile) {
        totalCountHeader.html(this.totalCountHeaderTemplate({
          count: this.model.state.totalRecords,
          declinationHelper: app.helpers.DeclinationHelper,
        }));
      }
      if (this.model.models.length === 0) {
        this.updateFoundCategoriesHeader(0);
      }
      this.infiniteRender();
      this.rewritePageLinks();
      if (!!(window.performance && window.performance.timing)) {
        var className = $('.catalog__item-preview img').length ? '.catalog__item-preview img' : '.product__image img';
        app.SEND_TO_OKO_RESOURCE_TIMING_LOAD_IMAGES(className, 'perf-image');
        if (typeof window.performance.clearResourceTimings === 'function') {
          window.performance.clearResourceTimings();
        }
      }
      return this;
    },

    /**
     * Рендер для бесконечного скролла
     * @param {Array} [changedKeys] Если изменились гет параметры, не нужно скроллить к последнему.
     */
    infiniteRender: function(changedKeys) {
      if (this.model.mode === 'infinite') {
        var shouldScroll = changedKeys ? !changedKeys.length : true;
        this.scrollToLastItem(shouldScroll);
        this.togglePreventScroll(false);
        this.infinitePreloader.remove();
      }
    },

    /**
     * При бесконечном скролле прокручиваем окно к позиции товара, который был последним перед подгрузкой новых товаров.
     * @param {boolean} shouldScroll
     */
    scrollToLastItem: function (shouldScroll) {
      var item = '.tiles-views .catalog__item.tile';
      if (this.model.viewtype === 'cards') {
        item = '.tiles-views .product.tile';
      }
      if (shouldScroll && !this.lastElemPosition && $(item).length) {
        this.lastElemPosition = $(item).last().offset().top;
        this.lastItemsQtyOnPage = $(item).length;
      }
      if (shouldScroll
        && this.lastElemPosition
        && this.lastItemsQtyOnPage < $(item).length
      ) {
        $(window).scrollTop(this.lastElemPosition - 200);
        this.lastElemPosition = $(item).last().offset().top;
        this.lastItemsQtyOnPage = $(item).length;
      }
    },
    /**
     * Очищаем сохраненную позицию прокрутки.
     */
    clearScrollState: function () {
      this.lastElemPosition = null;
      this.lastItemsQtyOnPage = null;
    },
    /**
     * Рендер количества избранных товаров во всех категориях.
     * @param chosenCount
     * @param chosenFilters
     * @param filters
     */
    renderWishItemsCounter: function (chosenCount, chosenFilters, filters) {
      var total = _.get(filters, 'total.attributes.count') || this.model.state.totalRecords || 0,
        selectedAll;
      selectedAll = !chosenFilters.findWhere({paramName: 'category'});
      this.$('.all-in-wish').html(this.wishItemsCounterTemplate({total: total, selectedAll: selectedAll}));
      this.$('#filter-categories').toggleClass('not_display', !Object.keys(filters.data).length);
    },

    /**
     * Для категорий, в которых возможно удаление item'ов
     * @param qty - количество удаляемых из избранного товаров.
     */
    updateOnRemoveAndAdd: function (qty) {
      this.model.changed = true;
      // Если удалили последний товар и есть фильтры по категории, сбрасываем фильтры
      if (qty === this.model.state.totalRecords && this.model instanceof app.WishItems) {
        this.resetCategoryFilters();
        this.model.fetch();
        this.$('#filter-category-list').html('');
      } else {
        if (this.model.mode === 'infinite') {
          this.router.infiniteFetch();
          this.model.getFirstPage();
        } else {
          //если со страницы избранного удаляются последние товары, показываем предыдущую страницу
          if (qty && this.model.state.currentPage !== 1 && this.model.state.itemsInResponse - qty === 0) {
            this.model.getPage(this.model.state.currentPage - 1);
          } else {
            this.model.fetch();
          }
        }
      }
      this.render();
      this.$('#c12345').prop('checked', false);
    },
    /**
     * Триггерит роут с полученным объектом фильтров.
     * @param filterData
     */
    updateModelFilters: function (filterData) {
      this.router.navigate('/', {
        trigger: true,
      }, {
        f: JSON.stringify(filterData),
      });
    },

    /**
     * Сбрасываем фильтр по категории.
     */
    resetCategoryFilters: function () {
      var filterData = this.model.getFilter();
      if (_.isObject(filterData)) {
        delete filterData.category;
      }
      this.updateModelFilters(filterData);
    },
    /**
     * Получение id текущей категории.
     */
    getCategoryId: function () {
      this.model.categoryId = parseInt(this.$('.catalog-holder').data('category-id'), 10) || 0;
    },
    /**
     * Показать все категории на мобильной версии
     */
    showAllCategories: function () {
      if (app.isMobile) {
        this.scrollTop = $(document).scrollTop();
      }
    },
    /**
     * Скрыть показанные категории на мобильной версии
     */
    hideLastCategories: function () {
      if (app.isMobile) {
        $('html, body').animate({ scrollTop: this.scrollTop }, 500);
      }
    },
    /**
     * Выпадающее меню сортировки на мобильной версии
     */
    showSort: function () {
      this.$('.catalog-sort').toggleClass('active');
      if (app.isMobile) {
        if (this.$('.filter_but').hasClass('active')) {
          this.toggleFilters();
        }
      }
    },
    /**
     * Загрузка фильтров и их показ
     * @param {Event} e
     */
    loadFilters: function (e) {
      e.preventDefault();
      e.stopPropagation();
      Backbone.trigger('openFilters');
    },

    /**
     * Смена нового вида подкатегорий канцтоваров на старый при выборе
     * любого из фильтров
     */
    changeCategoryWrapper: function () {
      if (this.jsModel === 'without-items') {
        this.$('.category-menu-tile').addClass('not_display');
        this.$('.for-cat-without-items').css({
          visibility: 'visible',
          height: '100%',
          opacity: '1',
          overflow: 'visible',
        });
      }
    },
    /**
     * Пользователю больше 18 лет.
     */
    setMature: function () {
      if (!this.user.get('is_mature')) {
        this.user.set({is_mature: 1, scenario: 'api-confirmation'});
        this.user.save();
        this.$('.item-protected-blank').addClass('not_display');
        $('body').removeClass('not-mature');
      }
    },
    /**
     * Показ попапа с подкатегориями.
     */
    _showPopupSubCategory: function () {
      var $popup = $('.b-popup_font-ml');
      $('.opener').each(function (i) {
        new als.Popup($popup.eq(i), $(this), undefined, 150, undefined, '.js-positioner');
        $popup.eq(i).appendTo('.popups');
      });
    },
    /**
     * Собираем данные о всех подфильтровых страницах в категории и сохраняем в их коллекцию
     */
    saveFilterPagesToModel: function () {
      var pages = $('.js-filter-page').map(function (index, el) {
        var data = el.dataset,
          filter;
        try {
          filter = JSON.parse(data.filter);
        } catch (e) {
          filter = null;
        }
        return {
          id: _.toNumber(data.id),
          filter: filter,
          slug: data.slug,
        };
      });
      this.model.setFilterPages(pages);
    },
    /**
     * Обновляем значение активной подфильтровой страницы.
     *
     * @param {object} page
     */
    updateFilterPageModel: function (page) {
      if (this.activeFilterPageModel.id !== page.id) {
        this.activeFilterPageModel.set({id: page.id});
        this.activeFilterPageModel.fetch();
      }
    },
    /**
     * Очищаем значение активной подфильтровой страницы.
     */
    clearFilterPage: function () {
      this.activeFilterPageModel.clear();
    },
    /**
     * Обновляем урл, заголовок и описание страницы из данных о подфильтровой странице.
     *
     * @param {app.FilterPage} filterPage
     */
    updateLayoutOnFilterPageApplied: function (filterPage) {
      if (filterPage.isNew()) {
        app.baseFilterPageUrl = '';
        app.filterUrlParam = '';
        this.$('.title_home').html(this.categoryHeaderText);
        this.seoTextInitialize();
        this.$('.js-hidden-on-pfs').removeClass('not_display');
      } else {
        if (this.model.fetchCounter > 1) {
          var slug = filterPage.get('slug'),
            path = app.helpers.UrlHelper.getPathname();
          if (app.isMobile && app.baseFilterPageUrl) {
            path = '/' + app.baseFilterPageUrl + '/';
          }
          if (slug && path.indexOf(slug) < 0) {
            // добавляем к слагу ПФС все параметры кроме фильтров
            var params = app.helpers.UrlHelper.getUrlParameters();
            delete params.f;
            slug = String(slug).split('/').reverse()[0] + '/';
            slug = app.helpers.UrlHelper.to(slug, null);
            this.router.navigate('/', {
              trigger: false,
              replace: true,
              rootUrl: path + slug,
            }, params);
          }
          app.baseFilterPageUrl = filterPage.get('base_url');
          app.filterUrlParam = filterPage.get('filters');
          this.$('.title_home').html('<div class="likeH1">' + filterPage.get('name') + '</div>');
          this.seoTextInitialize();
          this.$('.js-hidden-on-pfs').addClass('not_display');
        }
      }
      this.initPopups();
    },
    /**
     *  Инициализация попапов
     */
    initPopups: function () {
      var that = this;
      if (this.childViews.popups.length) {
        _.each(this.childViews.popups, function (popup) {
          popup.remove();
        });
      }
      this.childViews.popups = [];
      this.$('.js-popup-left-opener').each(function () {
        that.childViews.popups.push(
          new app.PopupView({
            el: $(this),
            css: function (opener) {
              var leftOffset = opener.offset().left;
              var topOffset = opener.offset().top + opener.innerHeight() + 10;
              if (!app.isDesktop) {
                leftOffset = leftOffset - $('body').position().left;
                topOffset = topOffset - $('body').position().top;
              }
              return {
                left: leftOffset,
                top: topOffset,
              };
            },
          }));
      });
    },

    /**
     * Сворачивает меню категорий в одну строку, добавляет кнопку "ещё..".
     */
    wrapCategoryMenuInOneRow: function () {
      this.$categoryList.removeClass('one-row');
      this.$moreButton && this.$moreButton.remove();
      this.$categoryItems = this.$categoryItems || this.$categoryList.find('.js-positioner');
      this.$moreButton = app.helpers.DomHelper.hideExcessElementsAndAddButton(
        this.$categoryList,
        this.$categoryItems,
        1,
        this.moreButtonTemplate,
        this.expandCategoryMenu.bind(this)
      );
      this.$categoryList.addClass('one-row');
    },

    /**
     * Разворачивает скрытые категории.
     */
    expandCategoryMenu: function () {
      this.$('.js-categories-link-more').addClass('not_display');
      this.$categoryItems.removeClass('not_display');
      this.$moreButton.remove();
      this.stopListening(Backbone, 'window.resize.debounced', this.wrapCategoryMenuInOneRow);
      this.$categoryList.addClass('expanded');
    }
  });
})(jQuery);

}.call(window));